'use client';

import { useInfiniteQuery } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';

import { getInfinityArticles } from '@/features/articles';
import { useViewed } from '@/features/viewed';
import { Article } from './Article';

export const NotViewed = () => {
  const { data, hasNextPage, fetchNextPage, isFetching } = useInfiniteQuery(
    getInfinityArticles({ key: 'not-viewed', limit: 5 })
  );

  const viewedArticles = useViewed((state) => state.articles);

  const articles = useMemo(() => {
    return (
      data?.pages
        .flatMap((page) => page.articles)
        ?.filter((item) => !viewedArticles.includes(item.id!)) ?? []
    );
  }, [data, viewedArticles]);

  useEffect(() => {
    if (hasNextPage && !isFetching && articles.length < 5) {
      fetchNextPage();
    }
  }, [hasNextPage, isFetching, fetchNextPage, articles]);

  if (!articles.length) return null;

  return <Article title="Непросмотренные" articles={articles.splice(0, 5)} />;
};
